// OfflinePage.js
import React from 'react';
import styles from './offlinePage.module.css';

const OfflinePage = ({ onRetry }) => {
  return (
    <div className={styles.offlinePage}>
      <div className={styles.content}>
        {/* آیکون با افکت امواج */}
        <div className={styles.waveIcon}>
          <i className="bi bi-wifi-off"></i>
          <div className={styles.waves}>
            <div className={styles.wave}></div>
            <div className={styles.wave}></div>
            <div className={styles.wave}></div>
          </div>
        </div>
        
        <h2 className={styles.title}>اتصال اینترنت قطع شد</h2>
        
        <p className={styles.description}>
          لطفاً اتصال اینترنت خود را بررسی کنید
        </p>
        
        <button 
          onClick={onRetry}
          className={styles.retryButton}
        >
          <i className="bi bi-arrow-clockwise"></i>
          تلاش مجدد
        </button>
      </div>
    </div>
  );
};

export default OfflinePage;